module.exports = __webpack_public_path__ + "static/media/Experience.2969cf7e.png";